import React from 'react';
import { IBestDataset } from '../../../../../types/analytics';
import { IEnrichedMetadata } from '../../../../../types/metadata';
import { IAnalytcisUserInput } from '../../../../../types/IAnalyticsUserInput';
import { MarkerItem } from '../../../../../types/home';
import Persistence from '../Plot/Persistence/Persistence';
import { TabKey } from '../../../../../utils/common';
import { IAdvancedAnalyticsApiPayload } from '../../../../../types/chart';

interface PersistenceBoxProps {
  activePlotAnalytics: string | null;
  isUpdating: boolean;
  previewDatasetId: string;
  coordinates: number[];
  categoryDataset: IBestDataset[];
  dateRange: any;
  enrichedMetadata: IEnrichedMetadata[];
  onUpdate: (payload: IAdvancedAnalyticsApiPayload) => void;
  persistenceImage: string;
  error: string;
  persistenceLinks: string[];
  pointName: string;
  userInput: IAnalytcisUserInput;
  updateUserInput: (update: Partial<IAnalytcisUserInput>) => void;
  onDatasetChange: (value: string) => void;
  gridCellSize: string;
  waterDepth: string;
  point?: MarkerItem;
  onChangeActiveKey: (item: any, key?: TabKey) => void;
  pointOption: { label: string; value: string }[];
  isForAllAnalytics: boolean;
  setIsForAllAnalytics: (value: boolean) => void;
  isOfflineDataset: boolean
  globalDateRange: any[];
  setGlobalDateRange: (value: any[]) => void;
}

const PersistenceBox: React.FC<PersistenceBoxProps> = ({
  activePlotAnalytics,
  isUpdating,
  previewDatasetId,
  coordinates,
  categoryDataset,
  dateRange,
  enrichedMetadata,
  onUpdate,
  persistenceImage,
  error,
  persistenceLinks,
  pointName,
  userInput,
  updateUserInput,
  onDatasetChange,
  gridCellSize,
  waterDepth,
  point,
  onChangeActiveKey,
  pointOption,
  isForAllAnalytics,
  setIsForAllAnalytics,
  globalDateRange,
  setGlobalDateRange,
  isOfflineDataset
}) => {
  if (activePlotAnalytics !== 'Weather windows') {
    return null;
  }

  return (
    <Persistence
      updating={isUpdating}
      previewDatasetId={previewDatasetId}
      coordinates={coordinates}
      categoryDataset={categoryDataset}
      dateRange={dateRange}
      enrichedMetadata={enrichedMetadata}
      onUpdate={onUpdate}
      persistenceImage={persistenceImage}
      error={error}
      persistenceLinks={persistenceLinks}
      pointName={pointName}
      userInput={userInput}
      updateUserInput={updateUserInput}
      onDatasetChange={onDatasetChange}
      gridCellSize={gridCellSize}
      waterDepth={waterDepth}
      point={point}
      onChangeActiveKey={onChangeActiveKey}
      pointOption={pointOption}
      isForAllAnalytics={isForAllAnalytics}
      setIsForAllAnalytics={setIsForAllAnalytics}
      globalDateRange={globalDateRange}
      setGlobalDateRange={setGlobalDateRange}
      isOfflineDataset={isOfflineDataset}
    />
  );
};

export default PersistenceBox;
